export default [
  {
    path: 'typologies',
    name: 'offerTypologies',
    children: [
      {
        path: 'duplicate',
        name: 'offerTypologiesDuplicate',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_ADD',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },
            {
              text: 'offer.typology.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.duplicate',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'show',
        name: 'offerTypologiesShow',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_VIEW',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },
            {
              text: 'offer.typology.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.show',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'edit',
        name: 'offerTypologiesEdit',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_EDIT',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },
            {
              text: 'offer.typology.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.edit',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
    ],
  },
]
